import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  private readonly storage: Storage | null;
  private readonly isBrowser: boolean;
  private readonly navigator: any;
  private readonly window: any;
  private readonly document: any;
  private readonly localStorage: any;

  domain: string = (environment as any).subDomain;

  constructor(@Inject(PLATFORM_ID) private readonly platformId: object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    this.storage = this.isBrowser ? localStorage : null;
    this.navigator = this.isBrowser ? navigator : null;
    this.window = this.isBrowser ? window : null;
    this.document = this.isBrowser ? document : null;
  }

  setItem(key: string, value: string): void {
    if (this.storage) {
      this.storage.setItem(key, value);
    }
  }

  getItem(key: string): string | null {
    return this.storage ? this.storage.getItem(key) : null;
  }

  removeItem(key: string): void {
    if (this.storage) {
      this.storage.removeItem(key);
    }
  }

  clear(): void {
    if (this.storage) {
      this.storage.clear();
    }
  }

  getLanguage(): string {
    if (this.navigator) {
      return this.navigator.language ?? 'en-US'; // Browser
    }
    return 'en-US'; // Fallback for server
  }

  getBrowser = () => this.isBrowser;

  getWindow = () => this.window;

  getDocument = () => this.document;

  getCookie(name: string): string | null {
    if (this.getDocument()) {
      const cookies = document.cookie.split('; ');
      for (const cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split('=');
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
    }
    return null;
  }

  setCookie(name: string, value: string): void {
    // Hardcoded expiration for 1 day
    const expires = new Date();
    expires.setTime(expires.getTime() + 1 * 86400000);

    // Determine domain dynamically
    const host = this.isBrowser ? this.getWindow().location.hostname : 'localhost';
    const domain = host === 'localhost' ? 'localhost' : this.domain;

    const cookie = `${name}=${encodeURIComponent(
      value,
    )}; expires=${expires.toUTCString()}; path=/;${
      domain !== 'localhost' ? ` domain=${domain};` : ''
    }`;

    if (this.isBrowser) {
      document.cookie = cookie;
    }
  }

  deleteCookie(name: string) {
    if (this.isBrowser) {
      const host = this.isBrowser ? this.getWindow().location.hostname : 'localhost';
      const domain = host === 'localhost' ? 'localhost' : this.domain;
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
    }
  }
}
